import React from 'react';
import { Reveal } from './Reveal';
import { stats } from '../data/stats';
export function StatsBar() {
  return <section aria-label="La collection en chiffres" className="border-y border-brand-line bg-white py-9" data-id="element-266" data-mp="1tbjghngupucr">
      <Reveal className="mx-auto grid max-w-6xl grid-cols-2 gap-y-8 px-4 text-center md:grid-cols-4 md:gap-8" data-id="element-267" data-mp="1oa3vfveobnud">
        {stats.map(([value, label], index) => <div key={label} className={`flex flex-col items-center justify-center ${index > 0 ? 'md:border-l md:border-brand-line' : ''}`} data-id="element-268" data-mp="1ecz7pr56jkbg" data-mpi={index}>
            <span className="mb-1 text-3xl font-extrabold tracking-tight text-brand-navy md:text-4xl" data-id="element-269" data-mp="19ko6mkypdshb">{value}</span>
            <span className="text-[10px] font-bold uppercase tracking-wider text-slate-600 md:text-xs" data-id="element-270" data-mp="10lt35gn1mwhp">{label}</span>
          </div>)}
      </Reveal>
    </section>;
}